module.exports = __webpack_public_path__ + "static/media/stratego.97b74327.png";